import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import * as moment from "moment";
import { Observable } from "rxjs/Observable";

import { ExamineeRequestService } from "../request/examinee/examinee-request.service";
import { AccommsService } from "../services/accomms.service";
import { AppService } from "../services/app.service";
import { LoggerService } from "../services/audit-logger.service";
import { CommonService } from "../services/common.service";
import { PersonService } from "../services/person.service";
import { RequestHistoryService } from "../services/requesthistory.service";
import { TestService } from "../services/test.service";
import { User } from "../services/user.model";
declare var jQuery: any;

@Component({
  selector: "app-request-history",
  templateUrl: "./request-history.component.html",
  styleUrls: ["./request-history.component.css"]
})
export class RequestHistoryComponent implements OnInit {
  public dynamicContent: any;
  public sasId: string;
  public aId: string;
  public assignTA: string;
  public reqHistoryFor: string;
  public personId: string;
  public taaPin: string;
  public isLoading: boolean = false;
  public isDateLoading: boolean = false;
  public data = [];
  public loaderCount: number = 0;
  public apiCount: number = 0;
  public actId: string = "";
  public studentStateId: string = "";
  public oldActId: string = "";
  public oldStudentStateId: string = "";
  public testOptions: any;
  public testDates: any;
  public showTestDiv: boolean = false;
  public selectedTestId: string = "";
  public selectedTestDateId: string = "";
  public selectedTestDateName: string = "";
  public optedTestDates: string = "";
  public userProfile: User;
  public confirmationModalMessage: string = "";
  public selectedModalType: string = "";
  public selectedReviewDetails: any;
  public savedTestDateIds: Array<any> = [];
  public isInvalidActId: boolean = false;
  public isUpdatedActId: boolean = false;
  public isUpdatedStudentId: boolean = false;
  public testDateAlreadyExists: boolean = false;
  public submitActID: string = "";
  public selectedTestType: string;
  public errorMsg: boolean = false;
  public testNotSelected: boolean = false;
  public blankIdCheck: boolean = false;
  public checkIdsValidation: boolean = false;
  public studentFirstName: string = "";
  public studentLastName: string = "";
  public studentMiddleName: string = "";
  public requests: any;
  public deleteDataDetails: any;
  public reviewToDate: any;
  public adminId: string;
  public extAdminId: string;
  public regId: string;
  public dob: any;
  public hsCode: any;
  public sourceSystem: any;
  public studentDetails: any;
  public previousActId: string = "";
  public previousStudentStateId: string = "";
  public auditStatusText: string = "";
  public auditUserData: string = "";
  public requestStatusCode: string = "";
  public optedTestDateName: string = "";
  private studentDetailsMessageSubscription: any;
  public stateTestId: string;
  public orgDetails: object = {};
  public lastNm: string;
  public firstNm: string;
  public orgMdmId: string;
  public queryError:boolean = false;
  public recordDeleted:boolean = false;

  constructor(
    private commonService: CommonService,
    public requestHistoryService: RequestHistoryService,
    public testService: TestService,
    public accommsService: AccommsService,
    private examineeService: ExamineeRequestService,
    private router: Router,
    private _loggerService: LoggerService,
    private appService: AppService,
    private personService: PersonService
  ) { }

  ngOnInit() {
    this.data = [];
    this.appService.getUserProfile().then(user => (this.userProfile = user));
    this.isLoading = true;
    this.optedTestDates = "";
    if (sessionStorage.getItem("selectedStudent")) {
      this.studentDetails = JSON.parse(
        sessionStorage.getItem("selectedStudent")
      );
      this.studentFirstName = this.studentDetails.firstName;
      this.studentLastName = this.studentDetails.lastName;
      this.studentMiddleName = this.studentDetails.middleName
        ? this.studentDetails.middleName
        : "";
      this.reqHistoryFor = this.studentFirstName + " " + this.studentLastName;
      this.taaPin = this.studentDetails.taaPin;
      this.personId = this.studentDetails.personId;
    } else {
      this.studentDetails = this.commonService.getStudentDetails();
      this.studentFirstName = this.studentDetails.firstName;
      this.studentLastName = this.studentDetails.lastName;
      this.studentMiddleName = this.studentDetails.middleName
        ? this.studentDetails.middleName
        : "";
      this.reqHistoryFor = this.studentFirstName + " " + this.studentLastName;
      this.taaPin = this.studentDetails.taaPin;
      this.personId = this.studentDetails.personId;
    }
    if (sessionStorage.getItem("selectedOrg")) {
      this.orgDetails = JSON.parse(sessionStorage.getItem("selectedOrg"));
    }

    Observable.forkJoin(
      this.requestHistoryService.getRequest(this.personId)
    ).subscribe(([res]) => {
      Observable.forkJoin(
        this.commonService.getDynContent("SASID"),
        this.commonService.getDynContent("ACTID"),
        this.commonService.getDynContent("ASSIGN_TEST_ADMIN")
      ).subscribe(([sasId, aId, assignTA]) => {
        this.sasId = sasId;
        this.aId = aId;
        this.assignTA = assignTA;
      });
      const records: any = res.body;
      this.requests = res.body;
      this.isLoading = true;
      this.loaderCount = 0;
      this.apiCount = 0;
      for (let i = 0; i < records.length; i++) {
        this.hsCode = records[i].HS_CODE ? records[i].HS_CODE : "";
        this.orgMdmId = records[i].ORG_MDM_ID ? records[i].ORG_MDM_ID : "";
        this.sourceSystem = records[i].SOURCE_SYSTEM
          ? records[i].SOURCE_SYSTEM
          : "";
        this.data[i] = {};
        this.data[i].PERSON_ID = records[i].PERSON_ID;
        this.data[i].REQUEST_ID = records[i].REQUEST_ID;
        this.data[i].REQUEST_STATE_TX = records[i].REQUEST_STATE_TX;
        this.data[i].TEST_DATE_ID = records[i].TEST_DATE_ID;
        this.data[i].SUBMITTED_BY_NM = records[i].SUBMITTED_BY_NM;
        this.data[i].SUBMITTED_BY_DT = undefined;
        if (records[i].SUBMITTED_BY_DT !== null) {
          this.data[i].SUBMITTED_BY_DT = new Date(records[i].SUBMITTED_BY_DT);
        }
        setTimeout(
          count => {
            Observable.forkJoin(
              this.requestHistoryService.getTestNameById(
                records[count].TEST_ID
              ),
              this.requestHistoryService.getRequestStatusCodeById(
                records[count].REQUEST_STATUS_CODE_ID
              )
            ).subscribe(([test, status]) => {
              this.data[count].TEST_NM = test.body[0]
                ? test.body[0].TEST_NM
                : "";
              this.data[count].STATUS_CD = status.body[0]
                ? status.body[0].STATUS_CD
                : "";
              this.requestStatusCode = status.body[0]
                ? status.body[0].STATUS_CD
                : "";
              this.data[count].DISPLAY_CD = status.body[0]
                ? status.body[0].DISPLAY_CD
                : "";
            });
            Observable.forkJoin(
              this.requestHistoryService.getReviewDetails(
                records[count].REQUEST_ID
              )
            ).subscribe(([reviewResult]) => {
              this.data[count].DecisionDocument = reviewResult.body;
            });

            Observable.forkJoin(
              this.accommsService.getReqAccomsById(records[count].REQUEST_ID)
            ).subscribe(([reqAccoms]) => {
              const accomsName: any = reqAccoms.body;
              if (accomsName.length === 0) {
                this.getStudentDetails();
              } else {
                this.apiCount = this.apiCount + accomsName.length;
                for (let j = 0; j < accomsName.length; j++) {
                  this.data[count].ACCOMMODATION_ID =
                    accomsName[j].ACCOMMODATION_ID;
                  setTimeout(
                    num => {
                      Observable.forkJoin(
                        this.accommsService.getAccomsName(
                          accomsName[num].ACCOMMODATION_ID
                        )
                      ).subscribe(([accomsType]) => {
                        if (!this.data[count].ACCOMMODATION_DS) {
                          this.data[count].ACCOMMODATION_DS = "";
                        }
                        this.data[count].ACCOMMODATION_DS =
                          this.data[count].ACCOMMODATION_DS +
                          accomsType.body[0].ACCOMMODATION_DS +
                          "<br/>";
                        this.loaderCount = this.loaderCount + 1;
                        if (this.apiCount === this.loaderCount) {
                          this.getStudentDetails();
                        }
                      });
                    },
                    true,
                    j
                  );
                }
              }
            });
          },
          true,
          i
        );
      }
    });
  }

 ngOnDestroy() {}

  ngAfterViewChecked() {
    jQuery('.clickableHeader a').attr('tabindex', 0);
    jQuery('.clickableHeader a').each(function () {
      jQuery(this).attr('aria-label', jQuery(this).parent().attr());
    });
    jQuery('.clickableHeader a').on('keydown', function (evt) { 
      if (evt.keyCode === 13 || evt.keyCode === 32) {
        evt.target.click();
        evt.stopPropagation();
        evt.preventDefault();
      }
      return !(evt.key == ' ' && evt.target == document.body);
    });
}

  getStudentDetails() {
    setTimeout(() => {
      this.showTestDiv = false;
      this.data.forEach(element => {
        if (
          !(
            element.STATUS_CD === "Incomplete" ||
            element.STATUS_CD === "ReconsiderIncomplete"
          )
        ) {
          this.showTestDiv = true;
        } else {
          this.showTestDiv = false;
        }
      });
    }, true);
    Promise.all([
      new Promise((resolve, reject) => {
        Observable.forkJoin(
          this.requestHistoryService.getPersonById(this.personId)
        ).subscribe(
          ([personDetails]) => {
            this.dob = personDetails[0].BIRTH_DT;
            this.actId = personDetails[0].ACT_ID ? personDetails[0].ACT_ID : "";
            this.oldActId = personDetails[0].ACT_ID;
            this.previousActId = this.oldActId;
            this.studentStateId = personDetails[0].STATE_SYSTEM_ID;
            this.oldStudentStateId = personDetails[0].STATE_SYSTEM_ID;
            this.previousStudentStateId = this.oldStudentStateId;
            if (this.dob) {
              this.dob = moment(this.dob).format("MM-DD-YYYY");
            }
            resolve(personDetails[0]);
          },
          err => {
            reject(err);
          }
        );
      }),

      new Promise((resolve, reject) => {
        Observable.forkJoin(
          this.requestHistoryService.getPersonTestById(this.personId)
        ).subscribe(
          ([personTest]) => {
            resolve(personTest);
          },
          err => {
            reject(err);
          }
        );
      }),

      new Promise((resolve, reject) => {
        Observable.forkJoin(this.requestHistoryService.getTest()).subscribe(
          tests => {
            this.testOptions = tests[0];
            this.testOptions.forEach(element => {
              if (element.TEST_NM === "ACT State and District Testing") {
                this.stateTestId = element.TEST_ID;
              }
            });
            resolve(tests);
          },
          err => {
            reject(err);
          }
        );
      }),

      new Promise((resolve, reject) => {
        Observable.forkJoin(
          this.personService.getPersonNameById(this.personId)
        ).subscribe(
          ([personName]) => {
            this.firstNm = personName[0].FIRST_NM ? personName[0].FIRST_NM : "";
            this.lastNm = personName[0].LAST_NM ? personName[0].LAST_NM : "";
            resolve(personName);
          },
          err => {
            reject(err);
          }
        );
      })
    ]).then(value => {
      this.getSavedTestDates(value[1]);
    });
  }

  setSession(data) {
    const studentDetails = {
      personId: data.PERSON_ID,
      requestId: data.REQUEST_ID,
      activeIdx: parseInt(data.REQUEST_STATE_TX, 10) - 1,
      taaPin: this.taaPin,
      personName: this.reqHistoryFor
    };
    this.requestHistoryService
      .setValuesIsSession(data.PERSON_ID, data.REQUEST_ID)
      .subscribe(value => { });
    if (data.REQUEST_STATE_TX === "0") {
      studentDetails.activeIdx = 6;
    }
    sessionStorage.setItem("currentStudent", JSON.stringify(studentDetails));
    this.examineeService.currentRequest = studentDetails;
    this.router.navigate(["request"]);
  }
  routeToPage(data) {
    if (data.STATUS_CD === "Incomplete" && data.TEST_DATE_ID) {
      Observable.forkJoin(
        this.requestHistoryService.getTestDateNameById(data.TEST_DATE_ID)
      ).subscribe(([getdates]) => {
        if (getdates) {
          const cutOffDate: any = getdates.body[0].REQUEST_CUT_OFF_DT;
          if (new Date(cutOffDate).toISOString() < new Date().toISOString()) {
            const studentDetails = {
              personId: data.PERSON_ID,
              requestId: data.REQUEST_ID,
              activeIdx: 1,
              taaPin: this.taaPin,
              personName: this.reqHistoryFor
            };

            this.requestHistoryService
              .setValuesIsSession(data.PERSON_ID, data.REQUEST_ID)
              .subscribe(value => { });

            sessionStorage.setItem(
              "currentStudent",
              JSON.stringify(studentDetails)
            );
            this.examineeService.currentRequest = studentDetails;
            this.router.navigate(["request"]);
          } else {
            this.setSession(data);
          }
        }
      });
    } else {
      this.setSession(data);
    }
  }

  onSelectTestId() {
    this.selectedTestDateId = "";
    this.selectedTestDateName = "";
    this.testDateAlreadyExists = false;
    this.isDateLoading = true;
    this.testOptions.forEach(element => {
      if (element.TEST_ID === this.selectedTestId) {
        this.selectedTestDateName =
          this.selectedTestDateName + ", " + element.TEST_NM;
      }
    });

    let getTestDates: any;
    if (this.stateTestId === this.selectedTestId) {
      getTestDates = this.testService.getStateTestDatesById(
        this.stateTestId,
        this.orgDetails["mdmId"]
      );
    } else {
      getTestDates = this.requestHistoryService.getDates(this.selectedTestId);
    }
    getTestDates
      .finally(() => {
        this.isDateLoading = false;
      })
      .subscribe(testdates => {
        const data: any = testdates.body;
        this.testDates = [];
        data.forEach(element => {
          if (
            new Date(element.REQUEST_CUT_OFF_DT).toISOString() >
            new Date().toISOString()
          ) {
            if (!this.savedTestDateIds.includes(element.TEST_DATE_ID)) {
              this.testDates.push(element);
            } else {
              element.disable = true;
              this.testDates.push(element);
            }
          }
        });
      });
  }
  getSavedTestDates(data) {
    const array = [];
    data.forEach(element => {
      this.savedTestDateIds.push(element.TEST_DATE_ID);
      array.push(
        new Promise((resolve, reject) => {
          Observable.forkJoin(
            this.requestHistoryService.getTestDateNameById(element.TEST_DATE_ID)
          ).subscribe(
            ([dates]) => {
              resolve(dates.body[0]);
            },
            err => {
              reject(err);
            }
          );
        })
      );
    });
    Promise.all(array).then(value => {
      this.testType(value);
    });
  }

  testType(data) {
    const array = [];
    data.forEach(element => {
      array.push(
        new Promise((resolve, reject) => {
          Observable.forkJoin(
            this.requestHistoryService.getTestNameById(element.TEST_ID)
          ).subscribe(
            ([dates]) => {
              resolve(dates.body[0]);
            },
            err => {
              reject(err);
            }
          );
        })
      );
    });
    Promise.all(array).then(value => {
      this.isLoading = false;
      value.forEach((element, index) => {
        this.optedTestDates =
          this.optedTestDates +
          element.TEST_NM +
          "-" +
          data[index].TEST_DATE_NM +
          (index !== value.length - 1 ? ", " : "");
      });
    });
  }

  updateActId() {
    this.errorMsg = false;
    const obj = {
      ACT_ID: this.submitActID,
      PERSON_ID: this.personId,
      UPDATED_BY_DS: this.userProfile.userName
    };
    this.requestHistoryService.updatePersonActID(obj).subscribe(response => {
      if (response.status === 200) {
        this.testNotSelected = false;
        this.isUpdatedStudentId = false;
        this.isUpdatedActId = true;
        this.oldActId = this.actId;
      } else {
        this.isUpdatedActId = false;
        this.errorMsg = true;
      }
    });
  }
  updateStudentStateId() {
    this.errorMsg = false;
    const obj = {
      STATE_SYSTEM_ID: this.studentStateId,
      PERSON_ID: this.personId,
      UPDATED_BY_DS: this.userProfile.userName
    };
    this.requestHistoryService
      .updatePersonStudentStateId(obj)
      .subscribe(response => {
        if (response.status === 200) {
          this.testNotSelected = false;
          this.isUpdatedStudentId = true;
          this.isUpdatedActId = false;
          this.oldStudentStateId = this.studentStateId;
        } else {
          this.isUpdatedStudentId = false;
          this.errorMsg = true;
        }
      });
  }

  addingTest() {
    this.testDates.forEach(element => {
      if (element.TEST_DATE_ID === this.selectedTestDateId) {
        this.optedTestDateName = element.TEST_DATE_NM;
        this.selectedTestDateName =
          this.selectedTestDateName + "-" + element.TEST_DATE_NM;
      }
    });
    Observable.forkJoin(
      this.requestHistoryService.getPersonTestByTestId(
        this.personId,
        this.selectedTestDateId
      )
    ).subscribe(
      ([testDetails]) => {
        this.extAdminId = testDetails[0].EXT_ADMIN_ID
          ? testDetails[0].EXT_ADMIN_ID
          : "";
        this.regId = testDetails[0].REG_ID ? testDetails[0].REG_ID : "";
      },
      err => { }
    );

    this.testDateAlreadyExists = false;
    this.testNotSelected = false;
    this.isUpdatedStudentId = false;
    this.isUpdatedActId = false;
    this.checkIdsValidation = false;
    this.errorMsg = false;
    const personTest = {
      PERSON_ID: this.personId,
      TEST_DATE_ID: this.selectedTestDateId,
      CREATED_BY_DS: this.userProfile.userName,
      UPDATED_BY_DS: this.userProfile.userName
    };
    const data = {
      firstName: this.studentFirstName,
      lastName: this.studentLastName,
      TAA_PIN: this.taaPin,
      mode: "PBT"
    };

    const loggerModel = {
      MODULE_ID: "REQUEST",
      CATEGORY_ID: "ASSIGN_TEST_AMINISTRATION",
      COMPONENT_ID: "REQUEST_HISTORY_PAGE",
      CREATED_BY_DS: this.userProfile.userName,
      MESSAGE_TX: "Associated an examinee to a new test administration.",
      REFERENCE_ID: this.personId,
      SEVERITY_VAL: "",
      UPDATED_BY_DS: this.userProfile.userName,
      USER_DATA_VAL:
        "Examinee " +
        this.reqHistoryFor +
        " is associated with test administration " +
        this.selectedTestDateName
    };
    if (this.selectedTestDateId) {
      Observable.forkJoin(
        this.requestHistoryService.getTestDateNameById(this.selectedTestDateId)
      ).subscribe(([testType]) => {
        if (testType) {
          const data1: any = testType;
          this.selectedTestType = data1.body[0].TEST_DATE_TYPE;
          this.reviewToDate = data1.body[0].REVIEW_TO_DT;
          this.adminId = data1.body[0].ADMIN_ID;
        }
        if (this.selectedTestType === "State") {
          personTest["PERSON_TEST_TYPE"] = "State";
          this.requestHistoryService
            .postPersonTest(personTest)
            .subscribe(response => { });
          this.savedTestDateIds.push(this.selectedTestDateId);
          this.optedTestDates = this.optedTestDates + this.selectedTestDateName;
          this.selectedTestId = "";
          this.selectedTestDateId = "";
          this._loggerService
            .updateLog(loggerModel)
            .subscribe(success => { }, err => { });
        } else {
          Observable.forkJoin(
            this.requestHistoryService.postTestType(data),
            this.requestHistoryService.getPersonAddressById(this.personId)
          ).subscribe(([result, personAddress]) => {
            if (result.status === 200) {
              const addressDetails: any = personAddress;
              this.savedTestDateIds.push(this.selectedTestDateId);
              this.optedTestDates =
                this.optedTestDates + this.selectedTestDateName;
              this.selectedTestId = "";
              this.selectedTestDateId = "";
              if (result.body["Test Type"] === "Special") {
                personTest["PERSON_TEST_TYPE"] = result.body["Test Type"];
                personTest["CERTIFIED_FL"] = "Y";
                personTest["CERTIFIED_BY_DS"] =
                  this.userProfile.givenName +
                  " " +
                  this.userProfile.familyName;
                personTest["CERTIFIED_ON_DT"] = new Date();
              } else {
                personTest["PERSON_TEST_TYPE"] = "National";
              }
              Observable.forkJoin(
                this.requestHistoryService.postPersonTest(personTest),
                this.requestHistoryService.getSourceFlag()
              ).subscribe(([response, sourceFlag]) => {
                if (response.status === 200) {
                  this._loggerService
                    .updateLog(loggerModel)
                    .subscribe(success => { }, err => { });
                  const currentdate: any = new Date();
                  let details: any = {};
                  if (sourceFlag.body["sourceFlag"]) {
                    this.sourceSystem = "MyACT";
                  }

                  if (this.sourceSystem === "MyACT") {
                    details = {
                      sourceSystem: this.sourceSystem,
                      status: this.requestStatusCode,
                      registration_id: this.regId ? this.regId : "",
                      test_date: this.optedTestDateName,
                      adminId: this.adminId,
                      extAdminId: this.extAdminId,
                      request_status: "",
                      taa_pin: this.taaPin,
                      lName: this.lastNm,
                      fName: this.firstNm,
                      dob: this.dob,
                      actId: this.actId ? this.actId : "",
                      hsCode: this.hsCode,
                      orgMdmId: this.orgMdmId,
                      event: "accommodations.created"
                    };
                  } else {
                    details = {
                      sourceSystem: this.sourceSystem ? this.sourceSystem : "",
                      actId: this.actId ? this.actId : "",
                      zip: addressDetails[0].ZIP_POSTAL_CD,
                      extAdminId: "",
                      status: "",
                      dob: this.dob,
                      hsCode: this.hsCode,
                      state: addressDetails[0].STATE_CD,
                      lName: this.studentLastName,
                      taaPin: this.taaPin,
                      fName: this.studentFirstName,
                      city: addressDetails[0].CITY_NM,
                      adminId: this.adminId,
                      address: addressDetails[0].STREET_1_AD
                        ? addressDetails[0].STREET_1_AD
                        : "" + " " + addressDetails[0].STREET_2_AD
                          ? addressDetails[0].STREET_2_AD
                          : "",
                      countryCd: addressDetails[0].COUNTRY_CD,
                      mName: this.studentMiddleName,
                      regId: "",
                      orderId: ""
                    };
                  }

                  if (this.reviewToDate) {
                    if (
                      (this.selectedTestType === "National" ||
                        this.selectedTestType === "Special") &&
                      Date.parse(this.reviewToDate) >= Date.parse(currentdate)
                    ) {
                      if (
                        this.requestStatusCode === "Approved" ||
                        this.requestStatusCode === "PartiallyApproved"
                      ) {
                        Observable.forkJoin(
                          this.requestHistoryService.postAccomsType(data)
                        ).subscribe(([accommsType]) => {
                          const accommStatus: any = accommsType.body;
                          if (this.sourceSystem === "MyACT") {
                            details.request_status =
                              accommStatus.data.accomm_type;
                          } else {
                            details.status = accommStatus.data.accomm_type;
                          }
                          this.requestHistoryService
                            .postRabbitMq(details)
                            .subscribe(temp => {
                              const rabbitMq: any = temp;
                              if (
                                rabbitMq.status === 200 &&
                                rabbitMq.body.status ===
                                "Added sucessfully to RabbitMq"
                              ) {
                                console.log(
                                  "Added sucessfully to RabbitMq with type " +
                                  accommStatus.data.accomm_type
                                );
                                console.log(
                                  "Added sucessfully to RabbitMq message is " +
                                  details
                                );
                              }
                            });
                        });
                      } else {
                        this.requestHistoryService
                          .postRabbitMq(details)
                          .subscribe(temp => {
                            const rabbitMq: any = temp;
                            if (
                              rabbitMq.status === 200 &&
                              rabbitMq.body.status ===
                              "Added sucessfully to RabbitMq"
                            ) {
                              console.log(
                                "NotApproved Added sucessfully to RabbitMq"
                              );
                            }
                          });
                      }
                    }
                  }
                } else {
                  this.errorMsg = false;
                }
              });
            } else {
              this.errorMsg = false;
            }
          });
        }
      });
    } else {
      this.testNotSelected = true;
    }
  }
  onOpenHandled(id, prm) {
    this.selectedModalType = prm;
    if (prm === "studentId") {
      this.confirmationModalMessage =
        "Are you sure you want to update this State Student Id?";
    } else if (prm === "actId") {
      this.isInvalidActId = false;
      this.confirmationModalMessage =
        "Are you sure you want to update this Act Id?";
    } else if (prm === "testDateId") {
      this.confirmationModalMessage = `By clicking ok below, I certify that if the examinee is approved to test through the Special Testing 
      program during a National test window, I personally meet all of the requirements for the Special Testing coordinator as specified in 
      the ACT Policies for ACT Special Testing and that I, or a designated qualified member of my staff as specified in the ACT Policies for 
      ACT Special Testing, agree to administer tests in accordance to the policies and guidelines stated in the ACT Special Testing Administration 
      Manual included with the test materials shipment. I will ensure to maintain security and confidentiality of all testing materials; materials 
      will only be used for the examinee identified in this request and all materials will be returned to ACT within 24 hours upon completion of 
      the test administration. I understand that by agreeing to be a Special Testing coordinator, I consent to the ACT Privacy Policy 
      (http://www.act.org/content/act/en/privacypolicy.html), which is incorporated into these Policies for ACT Special Testing by reference, 
      including consent to the collection of my personally identifying information and its subsequent use and disclosure.`;
    }
    document.getElementById(id).style.display = "block";
  }

  onCloseHandled(id) {
    document.getElementById(id).style.display = "";
  }
  onUpdateHandled() {
    if (this.selectedModalType === "studentId") {
      this.auditStatusText =
        "State Student Id updated for " + this.reqHistoryFor;
      this.auditUserData =
        "Person_ID : " +
        this.personId +
        " BEFORE_IMAGE: { State Student Id:" +
        this.previousStudentStateId +
        "} AFTER_IMAGE:{State Student Id:" +
        this.studentStateId +
        "}";
      this.updateLogs();
      this.updateStudentStateId();
    } else if (this.selectedModalType === "actId") {
      this.auditStatusText = "Student ACT ID updated for " + this.reqHistoryFor;
      this.auditUserData =
        "Person_ID : " +
        this.personId +
        " BEFORE_IMAGE: { ACT ID:" +
        this.previousActId +
        "}  AFTER_IMAGE: { ACT ID:" +
        this.actId +
        "}";
      this.updateLogs();
      this.updateActId();
    } else if (this.selectedModalType === "testDateId") {
      this.addingTest();
    }
    this.onCloseHandled("conformationModal");
  }
  checkActId() {
    this.isUpdatedStudentId = false;
    this.isUpdatedActId = false;
    this.checkIdsValidation = false;
    this.testNotSelected = false;
    if (!this.studentStateId && !this.actId) {
      this.blankIdCheck = true;
    } else {
      this.blankIdCheck = false;
      this.submitActID = "";
      this.isUpdatedActId = false;
      this.submitActID = this.actId.replace(/-/gi, "");
      if (
        this.submitActID.length === 8 ||
        this.submitActID.length === 9 ||
        this.submitActID.length === 0
      ) {
        this.onOpenHandled("conformationModal", "actId");
      } else {
        this.isInvalidActId = true;
      }
    }
  }
  checkStudentId() {
    this.isUpdatedStudentId = false;
    this.isUpdatedActId = false;
    this.checkIdsValidation = false;
    this.testNotSelected = false;
    if (!this.studentStateId && !this.actId) {
      this.blankIdCheck = true;
    } else {
      this.blankIdCheck = false;
      this.onOpenHandled("conformationModal", "studentId");
    }
  }
  checkTestDateExists() {
    this.blankIdCheck = false;
    this.checkIdsValidation = false;
    this.testNotSelected = false;
    if (!this.studentStateId && !this.actId) {
      this.blankIdCheck = true;
      this.checkIdsValidation = true;
    } else if (this.selectedTestId !== "" && this.selectedTestDateId !== "") {
      const check: boolean = false;

      for (let i = 0; i < this.savedTestDateIds.length; i++) {
        if (this.savedTestDateIds[i] === this.selectedTestDateId) {
          this.testDateAlreadyExists = true;
          break;
        } else if (i === this.savedTestDateIds.length - 1) {
          this.testDateAlreadyExists = false;
          this.onOpenHandled("conformationModal", "testDateId");
        }
      }
      if (this.savedTestDateIds.length === 0) {
        this.testDateAlreadyExists = false;
        this.onOpenHandled("conformationModal", "testDateId");
      }
    } else {
      this.testNotSelected = true;
    }
  }
  getDecisionDocument(data) {
    const details = {
      REQUEST_ID: data.REQUEST_ID,
      PERSON_ID: data.PERSON_ID,
      CMS_ENC_KEY: data.CMS_ENC_KEY,
      fileName: data.DecisionDocument[0].FILE_NM,
      CMS_DOCUMENT_ID: "",
      REVIEW_DETAIL_ID: ""
    };
    Observable.forkJoin(
      this.requestHistoryService.getReviewDetails(data.REQUEST_ID)
    ).subscribe(([response]) => {
      if (response.body) {
        details.CMS_DOCUMENT_ID = response.body[0].CMS_DOCUMENT_ID;
        details.CMS_ENC_KEY = response.body[0].CMS_ENC_KEY;
        details.REVIEW_DETAIL_ID = response.body[0].REVIEW_DETAIL_ID;
        this.requestHistoryService.downloadFile(details);
      }
    });
  }

  getDecisionDocumentHistory(data) {
    const details = {
      PERSON_ID: this.personId,
      REQUEST_ID: data.REQUEST_ID,
      CMS_ENC_KEY: data.CMS_ENC_KEY,
      fileName: data.FILE_NM,
      CREATED_ON_DT: moment(data.CREATED_ON_DT).format("x"),
      CMS_DOCUMENT_ID: data.CMS_DOCUMENT_ID,
      REVIEW_DETAIL_ID: data.REVIEW_DETAIL_ID
    };
    this.requestHistoryService.downloadFile(details);
  }

  checkReviewDetails(data) {
    data = JSON.parse(JSON.stringify(data)).filter(item => {
      return (
        item.CMS_DOCUMENT_ID !== null && item.REVIEW_TYPE_CD !== "ACCEXTCONS"
      );
    });
    this.selectedReviewDetails = data;
    document.getElementById("decisionModal").style.display = "block";
  }

  openDeleteModal(data) {
    this.deleteDataDetails = data;
    //Validation before deleting the record
    Observable.forkJoin(
      this.commonService.getReviewDetailCount(this.deleteDataDetails.REQUEST_ID)
    ).subscribe(([ReviewDetailCount]) => {
      if (ReviewDetailCount === "0") {
        document.getElementById("deleteModal").style.display = "block";
      }
      else {
        if(ReviewDetailCount === "error"){
          this.queryError = true;
        }
        document.getElementById("showError").style.display = "block";
      }
    });
  }

  deleteRecord() {
    const details = {
      REQUEST_ID: this.deleteDataDetails.REQUEST_ID,
      PERSON_ID: this.deleteDataDetails.PERSON_ID
    };

    Observable.forkJoin(
      this.requestHistoryService.deleteDocumets(details)
    ).subscribe(([documentDeleted]) => {
      const documents: any = documentDeleted;
      if (
        documents.status === 200 &&
        documents.body.status === "Deleted successfully"
      ) {
        Observable.forkJoin(
          this.requestHistoryService.deleteRequestDetails(details)
        ).subscribe(([deletedRequest]) => {
          const request: any = deletedRequest;
          if (
            request.status === 200 &&
            request.body.status === "Deleted Request Successfully"
          ) {
            document.getElementById("deleteModal").style.display = "";
            this.recordDeleted = true;
            this.updateLogs(); 
            this.ngOnInit();
          }
          if (
            request.status === 200 &&
            request.body.status === "Deleted Successfully"
          ) {
            this.recordDeleted = true;
            this.updateLogs(); 
            this.router.navigate(["examinees"]);
          }
        });
      }
    });
  }
  gotoHome() {
    setTimeout(() => {
      this.router.navigate(["/examinees"]);
    }, 500);
  }
  updateLogs() {
    const loggerModel = {
      MODULE_ID: "REQUEST",
      CATEGORY_ID: this.recordDeleted ? "DELETE_RECORD" : "ASSIGN_TEST_AMINISTRATION",
      COMPONENT_ID: "REQUEST_HISTORY_PAGE",
      CREATED_BY_DS: this.userProfile.userName,
      MESSAGE_TX: this.recordDeleted ? "Student Record Deleted Successfully" : this.auditUserData,
      REFERENCE_ID: this.recordDeleted ? this.taaPin : this.personId,
      SEVERITY_VAL: "",
      UPDATED_BY_DS: this.userProfile.userName,
      USER_DATA_VAL: this.auditUserData
    };
    this._loggerService.updateLog(loggerModel).subscribe(
      success => { },
      err => {
        console.log(err);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./client/views/request-history/request-history.component.ts